import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "ContactDashboardPage" */
	'pages/supplier/Contact/ContactDashboardPage'));

export default [{ component, exact: true, path: '/supplier_contacts/:contactId' }];